import { API_VERSIONS, asinzenAdminApi } from "client/api";

export const removeAsin = async (params: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/admin/users/estimate-sales/asins/remove`, params);

export const addAsin = async (params: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/admin/users/estimate-sales/asins/add`, params);

export const calculateAsin = async (params: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/admin/users/estimate-sales/asins/cal`, params);

export const fetchAllAsins = async (categoryId: string) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .get(`/${API_VERSIONS}/admin/users/estimate-sales/category/asins/${categoryId}`);

export const fetchAllCategories = async (params: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .get(`/${API_VERSIONS}/admin/users/estimate-sales/${params.version}/${params.marketplace}`)

export const getCategory = async (params: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .get(`/${API_VERSIONS}/admin/users/estimate-sales/category/${params.version}/${params.marketplace}/${encodeURIComponent(params.category)}`)

export const createCategory = async (params: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/admin/users/estimate-sales/category/create`, params);

export const deleteCategory = async (categoryId: string) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .delete(`/${API_VERSIONS}/admin/users/estimate-sales/category/${categoryId}/delete`);

export const updateCategory = async (categoryId: string, params: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/admin/users/estimate-sales/category/${categoryId}/update`, params);

export const fetchAllEstSalesVersions = async (marketplace: string) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .get(`/${API_VERSIONS}/admin/users/estimate-sales/versions/${marketplace}`);

export const createEstSalesVersion = async (params: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/admin/users/estimate-sales/version/create`, params);

export const updateEstSalesVersion = async (params: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/admin/users/estimate-sales/version/update`, params);